import { User } from "lucide-react";
import type { Tables } from "@/integrations/supabase/types";

interface DiscussionRepliesProps {
  replies: (Tables<"property_discussions"> & {
    profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
  })[];
}

export const DiscussionReplies = ({ replies }: DiscussionRepliesProps) => {
  return (
    <div className="mt-4 space-y-3 pl-4 border-l-2">
      {replies.map((reply) => (
        <div key={reply.id} className="flex items-start space-x-3">
          <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
            <User className="h-5 w-5 text-gray-400" />
          </div>
          <div>
            <p className="font-medium">
              {reply.profiles?.first_name} {reply.profiles?.last_name}
            </p>
            <p className="text-sm text-muted-foreground mt-1">
              {reply.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};